import React from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { NotaryViewRequestDetails, OrigViewRequest } from "../components";
import { AdminViewRequest } from "../components/admin";

// Authenticated deep-link target for Message Center notification emails:
//   /notary/orders/:orderId  /originator/orders/:orderId  /admin/orders/:orderId
// Renders the role's existing order-detail component (which embeds the Message
// Center), keyed by the order's unique_id from the URL. A "Return to portal"
// link is always present so the user has an escape — including when an order
// isn't accessible (the detail components render an empty shell, not a crash,
// since server-side authorization gates the order-detail API).

const ROLE_HOME = {
    notary: '/notary',
    originator: '/originator',
    admin: '/admin',
};

const OrderView = ({ role }) => {
    const { orderId } = useParams();
    const { user } = useAuth0();
    const decodedId = decodeURIComponent(orderId);
    const home = ROLE_HOME[role] || '/';

    let detail = null;
    if (role === 'notary') {
        // status="scheduled" so the embedded Message Center renders — message
        // notifications only fire on active/assigned orders. profile mirrors the
        // notary-scheduled invocation so the detail fetch behaves identically.
        detail = <NotaryViewRequestDetails requestId={decodedId} profile={user && user.email} status="scheduled" role="notary" />;
    } else if (role === 'originator') {
        detail = <OrigViewRequest requestId={decodedId} status="pending" />;
    } else if (role === 'admin') {
        detail = <AdminViewRequest requestId={decodedId} />;
    }

    return (
        <div className="max-w-4xl mx-auto px-4 mt-4 mb-8">
            <div className="mb-4">
                <Link to={home} className="text-blue-600 hover:text-blue-700 font-medium">
                    ← Return to portal
                </Link>
            </div>
            {detail}
        </div>
    );
};

export const NotaryOrderView = () => <OrderView role="notary" />;
export const OriginatorOrderView = () => <OrderView role="originator" />;
export const AdminOrderView = () => <OrderView role="admin" />;

export default OrderView;
